import { render, staticRenderFns } from "./ModalRoot.vue?vue&type=template&id=b6f43e04&"
import script from "./ModalRoot.vue?vue&type=script&lang=js&"
export * from "./ModalRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports